import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SnackbarSuccessComponentProps {
  success: boolean;
  successMessage: string;
  hideSuccess: () => void;
}

const SnackbarSuccessComponent: React.FC<SnackbarSuccessComponentProps> = ({
  success,
  successMessage,
  hideSuccess,
}) => {
  const action = (
      <>     
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={hideSuccess}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </>    
  );

  return (
    <div>
      <Snackbar open={success} autoHideDuration={6000} action={action}  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} onClose={hideSuccess} 
         message={successMessage}
        >
        {/* <Alert
          onClose={hideSuccess}
          severity="success"
          variant="filled"
          sx={{ width: "50%" }}
        >
          {successMessage}
        </Alert> */}
      </Snackbar>
    </div>
  );
};

export default SnackbarSuccessComponent;
